import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../Loader";
import { Pagination } from "@mui/material";
import moment from "moment";
import Select from "react-select";


const ManageWalletHistory = () => { 
  const [features, setFeatures] = useState();
  const [data, setData] = useState([]);
  const [listPageData, setListPageData] = useState();
  const [token, setToken] = useState(localStorage.getItem("cms_token"));
  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [pageSize, setPageSize] = useState();
  const [pageApi, setPageApi] = useState(1);
  const [totalUser, setTotalUser] = useState(0);

  const [tradeNo, setTradeNo] = useState(null);

  const [userList, setUserList] = useState([]);

  useEffect(() => {
    setToken(localStorage.getItem("cms_token"));
    getWebPages();
    UserList();
  }, [pageApi,tradeNo]);

  const getWebPages = async () => {
    setIsLoading(true);
    try {
      const response = await axios
        .get(`${API_BASE_URL}/get-total-wallet-data`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            user_id: tradeNo ? tradeNo : "all",
            page: pageApi,
            limit: 10,
          },
        })
        .then((response) => {
          // console.log(response, "resss");
          setIsLoading(true);
          if (response?.data?.status) {
            const pricing_plan = JSON.parse(JSON.stringify(response.data));
            setData(pricing_plan.data);
            setTotalUser(response?.data?.total);
            const totalPageCount = Math.ceil(response?.data?.total_data / 10);
            setPageSize(totalPageCount);
            setIsLoading(false);  
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });

      //   dispatch(create_plan({plan:pricing_plan.data.plan_list}));
    } catch (e) {
      return null;
    }
  };
  const onTrademarkChange = (e) => {
    setTradeNo(e.target.value);
  };

  const handleSelect = (fieldName, selectedOption) => {
    // console.log(selectedOption, "opton");
    // setData({ ...data, [fieldName]: selectedOption.value });
    setTradeNo(selectedOption.value)
  };

  const selectStyles = (errorFieldName) => ({
    control: (provided) => ({
      ...provided,
      borderColor: provided.borderColor,
      boxShadow: provided.boxShadow,
      minHeight: 22,
      height: 33,
    }),
  });

  const UserList = async () => {
    setIsLoading(true);
    try {    
      setIsLoading(true);
      const plan_data = await axios.get(API_BASE_URL + "/get-user-list?page=1&limit=100");
      const pricing_plan = JSON.parse(JSON.stringify(plan_data.data));
      // console.log(plan_data.data.data, "plan_data");

      // console.log(pricing_plan, "pricing_plan.data");

      if (pricing_plan.status == 200) {
        setUserList(plan_data.data.data);
      }
    } catch (e) {
      return false;
    }
  };

  const planOption = [];
  userList?.forEach((item) => {
    planOption.push({ value: item.user_id, label: item.name });
  });

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Manage Wallet History </h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">CMS</a>
                      </li>
                      <li className="breadcrumb-item active">Manage Wallet History</li>
                    </ol>
                  </div>
                </div>
                <div className="d-flex justify-content-center align-items-center mb-4">
                  <h4 className="mb-sm-0 font-size-16 me-4">Search By User </h4>
                  <Select
                            className={`custom-select custom-select-sm me-2`}
                            options={planOption}
                            // value={planOption.filter(
                            //   (option) => option.value == tradeNo
                            // )}
                            styles={selectStyles("plan_id")}
                            name="plan_id"
                            onChange={(selectedOption) =>
                              handleSelect("plan_id", selectedOption)
                            }
                          >
                            <option value="">Select an option</option>
                            {planOption?.map((item) => (
                              <option value={item.value}>{item.label}</option>
                            ))}
                          </Select> 
                  <button className="date-submit" onClick={()=>setTradeNo(null)}>
                    Clear
                  </button>
                </div>
              </div>
            </div>
            {/* <div className="row d-flex text-end mb-2">
              <div className="col-lg-12 mb-2 ">
                <Link
                  to={"/cms/managePlan/add-subscription-plan"}
                  data-repeater-create
                  type="button"
                  className="btn btn-success inner"
                  value="Add Number"
                >
                  Add Subscription Plan
                </Link>
              </div>
            </div> */}

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title mb-4">
                      Documents List ({totalUser})
                    </h4>
                    {isLoading ? (
                      <Loader />
                    ) : (
                      <div className="table-responsive">
                        <table className="table align-middle table-nowrap mb-0">
                          <thead className="table-light">
                            <tr>
                              <th className="align-middle">User Id</th>
                              <th className="align-middle">Credit</th>
                              <th className="align-middle">debit</th>
                              <th className="align-middle">Date</th>
                              {/* <th className="align-middle">Api end point</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {data?.map((item) => (
                              <>
                                <tr>
                                  <td>{item.user_id}</td>
                                  <td>{item.credit ? item.credit : "0"}</td>
                                  <td>{item.debit ? item.debit : "0"}</td>

                                  <td>
                                    {moment(item.created_at).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </td>
                                  {/* <td>
                                    <Link
                                      to={`${item.doc_full_path}`}
                                      target="_blank"
                                      type="button"
                                      className="btn btn-success btn-sm btn-rounded waves-effect waves-light"
                                    >
                                      <i className="fa fa-eye"></i>
                                    </Link>
                                  </td> */}
                                </tr>
                              </>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {!isLoading && pageSize !== 1 && (
                      <div className="d-flex justify-content-center mt-2">
                        <Pagination
                          count={pageSize}
                          page={pageApi}
                          onChange={(e, value) => {
                            // console.log(value, "vslue");
                            setTradeNo(null);
                            setPageApi(value);
                          }}
                          color="primary"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageWalletHistory;
